module.exports = __webpack_public_path__ + "files/a09326edf3d15bcb5ed0572ac4cbbce3.svg";